export enum WidgetView {
  HOME = "home",
  CHAT = "chat",
  CHATS = "chats",
  ACCOUNT = "account",
  ORDERS = "orders",
  EDIT_ORDER = "edit-order",
}
